module.exports = "/images/save-search.png?0e7f470e8bc38f8ca813ffb806ceb11b";